"use client"

import { useRef, type AnchorHTMLAttributes } from "react"
import {
    TextScrambleAnimation,
    type TextScrambleAnimationHandle,
} from "./scramble-text"
import { cn } from "@/lib/utils"

export function ScrambleExternalLink({
    children,
    text,
    className,
    textContainerClassName,
    uppercase,
    ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
    text: string
    uppercase?: boolean
    textContainerClassName?: string
}) {
    const scrambleRef = useRef<TextScrambleAnimationHandle | null>(null)

    const handleMouseEnter = () => {
        scrambleRef.current?.play()
    }

    return (
        <a
            className={cn("relative", className)}
            onMouseEnter={handleMouseEnter}
            target="_blank"
            rel="noopener noreferrer"
            {...rest}
        >
            <TextScrambleAnimation
                text={text}
                ref={scrambleRef}
                uppercase={uppercase}
                className={cn(textContainerClassName)}
            />
            {children}
        </a>
    )
}
